import {
  LinearProgress,
  Card,
  CardContent,
  Typography,
  Grid,
  Tooltip,
  IconButton,
  Stack,
} from "@mui/material";
import Box from "@mui/material/Box";
import {
  DataGrid,
  GridPagination,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import ResponsiveDataGrid from "../../../../../../components/MobileList/ResponsiveDataGrid";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { JReports } from "../../../../../../app/slices/jomla/reportsSlice";
import DateRangepicker from "../../../../../../helpers/dateRangePicker";
import dayjs from "dayjs";
import { MdOutlineClear } from "react-icons/md";
import { SelectJItem } from "../../../../../../components/Selectors/jomla/SelectJItem";
import { JItems } from "../../../../../../app/slices/jomla/itemsSlice";
import { SelectJSubCategory } from "../../../../../../components/Selectors/jomla/SelectJSubCategory";
import { SelectJCategory } from "../../../../../../components/Selectors/jomla/SelectJCategory";
import { SelectJRep } from "../../../../../../components/Selectors/SelectJRep";

const JItemsSummaryTotal = () => {
  const dispatch = useDispatch();

  const [search, setSearch] = useState({
    startDate: dayjs().format("YYYY-MM-01"),
    endDate: dayjs().format("YYYY-MM-DD"),
    j_item_id: null,
    j_category_id: null,
  });

  const _JItemsSummaryTotal = useSelector(
    (state) => state.jReports.jItemsSummaryTotal
  );
  const loading = useSelector((state) => state.jReports.loading);
  const reportTypes = useSelector((state) => state.jReports.reportTypes);
  const _JItems = useSelector((state) => state.JItems.JItemsList.data);
  const _JSubCategory = useSelector(
    (state) => state.JSubCategories.JSubCategoriesList.data
  );
  const JCategory = useSelector(
    (state) => state.JCategories.JCategoriesList.data
  );
  const user = useSelector((state) => state.user.jRepList.data);
  const _Role = useSelector((state) => state.user.userInfo.user_roles[0]);
  const _UserInfo = useSelector((state) => state.user.userInfo);
  const PRIVILEGED_USER_ID = "ca40271f-cd02-4f18-b48a-83ae2e2b6fef";

  const columns = [
    {
      field: "index",
      headerName: "#",
      flex: 0.2,
    },
    {
      field: "j_item_name",
      headerName: "اسم المنتج",
      flex: 1,
      renderCell: (params) => (
        <span
          style={{
            fontWeight: params.row.j_item_id === "new" ? "bold" : "normal",
          }}
        >
          {params.value}
        </span>
      ),
    },
    {
      field: "j_item_code",
      headerName: "Code",
      flex: 0.5,
    },
    {
      field: "total_count",
      headerName: "العدد المباع",
      flex: 1,
      renderCell: (params) => (
        <span
          style={{
            fontWeight: params.row.j_item_id === "new" ? "bold" : "normal",
          }}
        >
          {params.value}
        </span>
      ),
    },
    {
      field: "total_sum",
      headerName: "مجموع السعر",
      flex: 1,
      renderCell: (params) => {
        return (
          <Typography
            style={{
              fontWeight: params.row.j_item_id === "new" ? "bold" : "normal",
            }}
          >
            {params.row.total_sum?.toLocaleString()}
          </Typography>
        );
      },
    },
    ...(_Role === "super_admin" || _UserInfo?.id === PRIVILEGED_USER_ID
      ? [
          {
            field: "total_revenue",
            headerName: "مجموع الربح",
            flex: 1,
            renderCell: (params) => {
              return (
                <Typography
                  style={{
                    fontWeight:
                      params.row.j_item_id === "new" ? "bold" : "normal",
                  }}
                >
                  {params.row.total_revenue?.toLocaleString()}
                </Typography>
              );
            },
          },
        ]
      : []),
  ];

  useEffect(() => {
    dispatch(
      JReports.jItemsSummaryTotal({
        start_date: search.startDate,
        end_date: search.endDate,
        j_item_id: search.j_item_id,
        j_category_id: search.j_category_id,
        j_sub_category_id: search.j_sub_category_id,
        j_rep_id: search.j_rep_id ?? "",
      })
    );
  }, [dispatch, reportTypes, search]);

  useEffect(() => {
    dispatch(JItems.getAllList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const customToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarExport
        csvOptions={{
          fileName: "مجموع حركات المادة | نظام دجلة",
          utf8WithBom: true,
        }}
      />
    </GridToolbarContainer>
  );

  function CustomFooter() {
    return (
      <Stack
        direction="row"
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <Typography color="primary" sx={{ marginX: 2 }}>
          القيمة الكلية : {_JItemsSummaryTotal.total_amount?.toLocaleString()}{" "}
          (IQD)
        </Typography>
        <GridPagination />
      </Stack>
    );
  }

  return (
    <Card>
      <CardContent>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item xs={12} md={2}>
            <DateRangepicker
              startDate={search.startDate}
              endDate={search.endDate}
              handleOnChange={(searchDate) => {
                const updatedFilter = {
                  from: dayjs(searchDate[0].startDate).format("YYYY-MM-DD"),
                  to: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                };
                if (
                  updatedFilter.from !== searchDate.startDate ||
                  updatedFilter.to !== searchDate.endDate
                ) {
                  setSearch({
                    ...search,
                    startDate: dayjs(searchDate[0].startDate).format(
                      "YYYY-MM-DD"
                    ),
                    endDate: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                  });
                }
              }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <SelectJItem
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  j_item_id: newValue ? newValue.id : null,
                });
              }}
              value={
                _JItems.filter((x) => x.id === search.j_item_id)[0] ?? null
              }
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <SelectJCategory
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  j_category_id: newValue ? newValue.id : null,
                });
              }}
              value={
                JCategory.filter((x) => x.id === search.j_category_id)[0] ??
                null
              }
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <SelectJSubCategory
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  j_sub_category_id: newValue ? newValue.id : null,
                });
              }}
              value={
                _JSubCategory.filter(
                  (x) => x.id === search.j_sub_category_id
                )[0] ?? null
              }
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <SelectJRep
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  j_rep_id: newValue ? newValue.id : null,
                });
              }}
              value={
                user.filter((user) => user.id === search.j_rep_id)[0] ?? null
              }
            />
          </Grid>
          <Grid item xs="auto" md={1}>
            <Tooltip title="الغاء الفلتر">
              <IconButton
                onClick={() => {
                  setSearch({
                    startDate: dayjs().format("YYYY-MM-01"),
                    endDate: dayjs().format("YYYY-MM-DD"),
                    j_item_id: null,
                  });
                }}
              >
                <MdOutlineClear />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ height: { xs: "auto", md: "80vh" }, width: "100%" }}>
              <ResponsiveDataGrid gridHeight={null}
                rows={[
                  ...(_JItemsSummaryTotal.data?.map((x, index) => ({
                    ...x,
                    index: index + 1,
                  })) ?? []),
                  {
                    j_item_id: "new",
                    index: "",
                    j_item_name: "المجموع",
                    total_count: _JItemsSummaryTotal.total_debt.count,
                    total_sum: _JItemsSummaryTotal.total_debt.total,
                    total_revenue: _JItemsSummaryTotal.total_debt.revenue,
                  },
                ]}
                getRowId={(params) => params.j_item_id}
                loading={loading}
                columns={columns}
                components={{
                  LoadingOverlay: LinearProgress,
                  Toolbar: customToolbar,
                  Footer: CustomFooter,
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default JItemsSummaryTotal;
